import script from "./BlockSlider.vue?vue&type=script&setup=true&lang=js"
export * from "./BlockSlider.vue?vue&type=script&setup=true&lang=js"

import "./BlockSlider.vue?vue&type=style&index=0&id=21d8b046&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-21d8b046"]])

export default __exports__